

<template>
    <div class="extract-modal" v-show="show" @click.self="closeModal()">
        <div class="extract-modal__content">
            <div class="extract-modal__content__header">
                <span class="extract-modal__content__header-title"> Histórico de consumo </span>
                <span class="extract-modal__content__header-close" @click="closeModal()"> X </span>
            </div>
            <div class="extract-modal__content__plans">
                <div class="extract-modal__content__plans-title">
                    <span>{{ getPlanType }}</span>
                </div>
                <div class="plans">
                    <div class="plans__plan" v-if="hasCoins">
                        <div class="plans__plan-amount">
                            <span> {{ getCoinsFormatted }} </span>
                        </div>
                        <div class="plans__plan-type">Moedas</div>
                    </div>
                    <div class="plans__plan" v-if="hasBonus">
                        <div class="plans__plan-amount">
                            <span> {{ getBonusFormatted }} </span>
                        </div>
                        <div class="plans__plan-type">Bonus</div>
                    </div>
                </div>
            </div>

            <extract-tabs :tabs="tabs" @setTab="setTab" />
            <div
                ref="extractList"
                class="extract-modal__content__extract-list"
                v-infinite-scroll="loadMoreExtractWithPagination"
            >
                <div v-if="hasItemsInExtractList && !hasItemsInLocalExtractList">
                    <p class="extract-modal__content__feedback">Nenhuma transação encontrada nesse período</p>
                </div>
                <div v-if="hasItemsInLocalExtractList">
                    <extract-line-details
                        showIcon
                        v-for="extract in localExtractList"
                        :key="extract.uuid"
                        :extract="extract"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExtractLineDetails from '@/components/supplier/dashboard/extract/extract-line-details.vue';
import { mapState } from 'vuex';
import ExtractTabs from './extract-tabs.vue';
import { configAxiosExtract } from '@/utils/api-instance';
import { tabs } from './tabsDictionary';
export default {
    name: 'ExtractModal',
    components: {
        'extract-line-details': ExtractLineDetails,
        'extract-tabs': ExtractTabs,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        extractList: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['close'],

    data: () => ({
        tabs: tabs,
        localExtractList: [],
        loading: false,
        pagination: {
            next: undefined,
        },
        isMobile: true,
    }),

    computed: {
        ...mapState('user', ['supplierData']),

        hasItemsInExtractList() {
            return this.extractList.length > 0;
        },
        hasItemsInLocalExtractList() {
            return this.localExtractList.length > 0;
        },

        getBonusFormatted() {
            return this.convertNumberToBRLModal(this.supplierData.bonus);
        },

        getCoinsFormatted() {
            return this.convertNumberToBRLModal(this.supplierData.coins);
        },

        hasBonus() {
            return parseFloat(this.supplierData.bonus) > 0;
        },
        hasCoins() {
            return parseFloat(this.supplierData.coins) > 0;
        },

        getPlanType() {
            return this.supplierData.planType;
        },

        getCurrentActiveTab() {
            return this.tabs.find((tab) => tab.active);
        },
        noMoreItems() {
            return this.pagination.next == undefined;
        },
    },

    mounted() {
        this.fetchExtractListWithDate();
    },

    methods: {
        setTab(index) {
            this.tabs.forEach((item, i) => (item.active = i === index));
            this.cleanData();
            this.forceExtractListScrollTop();
        },

        forceExtractListScrollTop() {
            this.$nextTick(() => {
                this.$refs.extractList.scrollTop = 0;
            });
        },

        closeModal() {
            this.localExtractList = [];
            this.tabs.forEach((item) => (item.active = false));
            this.tabs[0].active = true;
            this.$emit('close');
        },

        cleanData() {
            this.localExtractList = [];
            this.pagination = {
                next: undefined,
            };
        },

        async fetchExtractListWithDate(page = 1) {
            this.loading = true;

            const createdAtQuery =
                this.getCurrentActiveTab.value === 0
                    ? `?page=${page}`
                    : `?created_at_by_day=${this.getCurrentActiveTab.value}&page=${page}`;

            try {
                const { data } = await configAxiosExtract().get(createdAtQuery);
                this.localExtractList = [...this.localExtractList, ...data.results];
                this.pagination.next = data.next;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async loadMoreExtractWithPagination() {
            if (this.pagination.next) {
                const page = this.pagination.next.split('page=')[1];
                this.fetchExtractListWithDate(page);
            }
        },

        convertNumberToBRLModal(number) {
            number = number.split(',');
            number[0] = 'R$ ' + number[0].split(/(?=(?:...)*$)/).join('.');
            return number.join(',');
        }
    },

    watch: {
        getCurrentActiveTab() {
            this.fetchExtractListWithDate();
        },
    },
};
</script>

<style lang="scss" scoped>
.extract-modal {
    @media (min-width: 768px) {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 767px) {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
    }

    &__content {
        border-radius: 8px;
        background-color: #ffffff;
        /* box-shadow: 30px 0px 200px rgba(0, 0, 0); */
        @media (min-width: 768px) {
            width: 621px;
            max-height: 500px;
        }

        @media (max-width: 767px) {
            position: relative;
            width: 100%;
            height: 100%;
        }

        &__header {
            height: 80px;
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: center;
            position: relative;
            padding: 22px;

            border-radius: 8px;

            &-title {
                font-size: 18px;
                font-weight: bold;
                color: #707070;
                margin-bottom: 10px;
            }
            &-close {
                position: absolute;
                font-size: 18px;
                font-weight: bold;
                cursor: pointer;
                color: #a5a5a5;
                margin-left: auto;
                right: 20px;
            }
        }
        &__plans {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fafafa;
            height: 100px;

            margin-bottom: 20px;

            &-title {
                font-size: 14px;
                font-weight: bold;
                color: #007bff;
                padding: 12px;
            }

            &__content {
                display: flex;
                flex-direction: row;
            }
        }

        &__extract-list {
            @media (min-width: 768px) {
                padding: 0px 24px;
                overflow-y: scroll;
                margin: 20px 20px 0 20px;
                height: 236px;
            }

            @media (max-width: 767px) {
                margin: 6px 12px;
                padding-bottom: 60px;
            }

            &::-webkit-scrollbar {
                width: 8px;
                &-track {
                    background-color: white;
                }
                &-thumb {
                    background-color: #e9ecef;
                    border-radius: 4px;
                }
            }
        }
        &__feedback {
            text-align: center;
            font-size: 14px;
            color: #62727b;
            padding: 12px;
        }
    }
}

.plans {
    display: flex;
    flex-direction: row;

    &__plan {
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &-amount {
            font-size: 17px;
            font-weight: bold;
            color: #62727b;
        }
        &-type {
            font-size: 10px;
            font-weight: 300;
            color: #62727b;
        }
    }
}
</style>